
import {hdi} from "@/components/utils/HDeviceInfo.js";
import {hcf} from "@/components/utils/HComFunctions.js";

class HNewGameUIConfig {
    /*
    0 | main = 永利样式
    1 | sgui = sg样式
    2 | yase = ys样式
    3 | 91xj = hs样式
    4 | jmtt = mh样式
    */

    static newGameUIType = 0; //要一起改
    static newGameUISuffix = "main";//要一起改

    //这里是当前项目的用户的userid(根据每个项目自己自定义返回平台用户的userid)
    static getProjectUserId(){
        return "main";
    }

    // 仅根据 appId 切换 UI 主题相关变量，不动 channelFlag/登录身份
    static _applyUIVarsByAppId(appId) {
        // 防止从 91xj 切回别的样式时 vant 暗色残留
        document.documentElement.classList.remove('van-theme-dark');
        switch (appId) {
            // dxsp 复用 sgui 的游戏 UI（type1/sg 皮肤），仅 UI 对齐；channelFlag 仍为 dxsp（见 setNewGameUITypeByAppId）
            case "dxsp":
            case "sgui":
                HNewGameUIConfig.newGameUIType = 1;
                hcf.setTheme("custom-theme-sgui");
                HNewGameUIConfig.newGameUISuffix = "sg";
                break;
            case "yase":
                HNewGameUIConfig.newGameUIType = 2;
                hcf.setTheme("custom-theme-yase");
                HNewGameUIConfig.newGameUISuffix = "ys";
                break;
            case "hsxs":
            case "91xj":
            case "ap03":
                //设置vant深色
                document.documentElement.classList.add('van-theme-dark');
                HNewGameUIConfig.newGameUIType = 3;
                hcf.setTheme("custom-theme-91xj");
                HNewGameUIConfig.newGameUISuffix = "hs";
                break;
            case "jmtt":
            case "ap02":
                HNewGameUIConfig.newGameUIType = 4;
                hcf.setTheme("custom-theme-jmtt");
                HNewGameUIConfig.newGameUISuffix = "jmtt";
                break;
            default:
                HNewGameUIConfig.newGameUIType = 0;
                HNewGameUIConfig.newGameUISuffix = "main";
                break;
        }
        //设置全局颜色
        document.documentElement.style.setProperty('--van-primary-color', hcf.getMainColor())
    }

    // 旧入口：行为完全不变 —— 切 UI + 把 channelFlag 也设为该 appId（用于 py 跳转/平台登录场景）
    static setNewGameUITypeByAppId(appId) {
        hdi.channelFlag = appId;
        HNewGameUIConfig._applyUIVarsByAppId(appId);
    }

    // 新入口：仅切 UI 主题，不修改 channelFlag（用于 ?ui= 调试预览，登录态/请求 channel 保持不变）
    static setUIOnlyByAppId(appId) {
        HNewGameUIConfig._applyUIVarsByAppId(appId);
    }
}

export default HNewGameUIConfig;
